<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div class="mb-6">
    <v-dialog
      ref="dialog"
      v-model="startDateDialog"
      max-width="298px"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="currentDate"
          :label="$t('selectDate')"
          hide-details
          outlined
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
        />
      </template>
      <v-date-picker
        v-model="currentDate"
        :locale="locale"
        :max="today"
        @input="startDateDialog=false"
      />
    </v-dialog>
  </div>
</template>

<script>

import { predefinedDateRangeList, today } from '@/model/utils/DateRepository'

export default {
  name: 'DateRangePicker',
  props: {
    locale: {
      default: 'en',
      type: String
    },
    value: {
      type: Array
    }
  },
  data: function () {
    return {
      today,
      currentDate: null,
      endDate: null,
      startDateDialog: null,
      endDateDialog: null,
      predefinedTimeList: predefinedDateRangeList
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.currentDate = val
      }
    },
    currentDate (val) {
      this.$emit('input', val)
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
